module.exports = __webpack_public_path__ + "img/ValidationReport_2.5db9cf30.jpg";